import PropTypes from 'prop-types';

import './fakeUi.scss';

const FakeUi = ({ opacity = 100 }) => {
  const opacityStyle = {
    opacity: parseInt(opacity, 10) / 100,
  };

  return (
    <div
      style={opacityStyle}
      className="iw-fake-ui"
    />
  );
};

FakeUi.propTypes = {
  opacity: PropTypes.number,
};

FakeUi.defaultProps = {
  opacity: 100,
};

export default FakeUi;
